import ItemCliente from "./ItemCliente";
import ItemPermiso from "./ItemPermiso";

export default class ItemUsuario {
    Id: number;
    CodOperario: number;
    CodigoCliente: string;
    IdUsuario: string;
    Nombre: string;
    Clave: string;
    IdTerminal: string;
    Activo: boolean;
    FechaDeActivacion: string;
    TipoDeOperario: string;
    KeyNotificacion: string;
    NombreCorto: string;
    Email: string;
    Telefono: string;
    UsuarioAdmin: boolean;
    SerialSIM: string;
    pIdentificador: string;
    PermisosApp: string;
    IdTerminalAsignado: number;
    Division: string;
    VersionApp: string;
    TiempoExpiracion: number;
    PermisosEolo: string;
    ClaveActivacion: string;
    Bloqueado: boolean;
    Descripcion: string;
    Token: string;
    VerPantallaInicio: boolean;
    ModoBienvenida: boolean;
    NombreEstado: string;
    ColorEstado: string;
    Iniciales: string;
    PermisoFueraHorario: boolean;
    Permisos: ItemPermiso[];
    Clientes: ItemCliente[] = [];

    constructor() {
        this.Id = 0;
        this.CodOperario = 0;
        this.CodigoCliente = "";
        this.IdUsuario = "";
        this.Nombre = "";
        this.Clave = "";
        this.IdTerminal = "";
        this.Activo = false;
        this.FechaDeActivacion = "";
        this.TipoDeOperario = "";
        this.KeyNotificacion = "";
        this.NombreCorto = "";
        this.Email = "";
        this.Telefono = "";
        this.UsuarioAdmin = false;
        this.SerialSIM = "";
        this.pIdentificador = "";
        this.PermisosApp = "";
        this.IdTerminalAsignado = 0;
        this.Division = "";
        this.VersionApp = "";
        this.TiempoExpiracion = 0;
        this.PermisosEolo = "";
        this.ClaveActivacion = "";
        this.Bloqueado = false;
        this.Descripcion = "";
        this.Token = "";
        this.VerPantallaInicio = false;
        this.ModoBienvenida = false;
        this.NombreEstado = "";
        this.ColorEstado = "";
        this.Iniciales = "";
        this.PermisoFueraHorario = false;
        this.Permisos = [];
        this.Clientes = [];
    };
};
